import { CustomFieldTypeIcon } from 'v5/patterns/widgets/customFieldTypeIcons';
import { CustomFieldDefinition } from '__types__';
import { FilterNumberConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createNumberFilterConfig(
  customFieldDef: CustomFieldDefinition
): FilterNumberConfig {
  return {
    label: customFieldDef.name,
    icon: <CustomFieldTypeIcon type={customFieldDef.data_type} />,
    type: 'number' as const,
    createDefaultValue: () => ({ operator: 'equal', value: 0 }),
    options: {}
  };
}
